
import axios from 'axios'
// -----------------------------------------------------------------------------
const api = axios.create({
  baseURL: 'https://plfilters.com/api/api/',
  // baseURL: 'http://127.0.0.1:8000/api/',
  // baseURL: 'https://plfilter.shlla.com/api/api/',
  headers: {
    'Content-Type': 'application/json'
  }
})
// -----------------------------------------------------------------------------
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }
  return config
}, error => {
  return Promise.reject(error)
})
// -----------------------------------------------------------------------------
const post = async (url, data, config = {}) => {
  try {
    // لأرسال التوكين فى الهيدر
    const payload = data.data || data // فك الداتا لو ملفوفة بـ data
    // لإرسال الهيدر فى البايلود
    // const token = localStorage.getItem('token')
    // const originalPayload = data.data || data
    // const payload = token
    //   ? { ...originalPayload, token }
    //   : originalPayload
    // -----------------------------------
    const response = await api.post(url, payload, config)
    return response.data
  } catch (error) {
    if (error && error.response) {
      const status = error.response.status
      if (status === 500) {
        throw new Error('حدث خطأ غير متوقع في الخادم. يرجى المحاولة مرة أخرى لاحقًا.')
      } else if (error.response.data) {
        throw error.response.data
      } else {
        throw new Error('حدث خطأ أثناء الاتصال بالخادم.')
      }
    } else {
      throw new Error('تعذر الاتصال بالخادم. تأكد من الاتصال بالإنترنت وحاول مرة أخرى.')
    }
  }
}
// -----------------------------------------------------------------------------
const API = {
  login: (data) => post('auth/login', data),
  getCustomers: (data) => post('get-customers-v2-', data),
  getCustomerData: (data) => post('get-customer-data', data),
  saveCustomer: (data) => post('saveCustomer', data),
  // -------------------------- contract ---------------------------------------
  getCustomerContract: (data) => post('getContract', data),
  saveCustomerContract: (data) => post('saveContract', data),
  deleteCustomerContract: (data) => post('deleteContract', data),
  saveCustomerPayment: (data) => post('save-customer-payment-v2-', data),
  // --------------------------
  getCustomerOffers: (data) => post('get-customer-offers-v2-', data),
  saveCustomerOffers: (data) => post('save-customer-offer-v2-', data),
  saveCustomerOfferItem: (data) => post('save-customer-offer-_item-v2-', data),
  // -----------------------------------------------------------------------------
  getCustomerStatement: (data) => post('get-customer-statement-v2-', data),
  // -----------------------------------------------------------------------------
  getCustomerCalls: (data) => post('get-customer-calls-v2-', data),
  saveCustomerCalls: (data) => post('save-customer-calls-v2-', data),
  deleteCustomerCalls: (data) => post('delete-customer-calls-v2-', data),
  // -----------------------------------------------------------------------------
  getMaintenanceStatement: (data) => post('get-customer-maintenance-v2-', data),
  // -----------------------------------------------------------------------------
  getCustomerInvoices: (data) => post('get-customer-invoice-v2-', data),
  saveCustomerInvoices: (data) => post('save-customer-invoice', data),
  // -----------------------------------------------------------------------------
  getItemSales: (data) => post('get-item-sales-v2-', data),
  saveItemSales: (data) => post('save-item-sales-v2-', data),
  deleteItemSales: (data) => post('delete-item-sales-v2-', data),
  // -----------------------------------------------------------------------------
  getInvoiceCandidates: (data) => post('get-invoice-candidates', data),
  // -----------------------------------------------------------------------------
  invoiceAction: (data) => post('invoice-action', data),
  // -----------------------------------------------------------------------------
  installmentPayment: (data) => post('saveInstallmentPaymrnt', data),
  installmentPaymentDelete: (data) => post('emptyInstallmentPaymrnt', data),
  getNextMaintenance: (data) => post('get-next-maintenance-v2-', data)
}
// -----------------------------------------------------------------------------
export default API



// WEBPACK FOOTER //
// ./src/store/api.js